module.exports = __webpack_public_path__ + "staticcomp/img/content_5.d27aef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/content_5.jpg
// module id = dszO
// module chunks = 39